import Header from '../components/Header'
import Hero from '../components/Hero'
import MenuSection from '../components/MenuSection'
import Footer from '../components/Footer'

export default function ClassicTemplate({ restaurant }) {
  return (
    <div className="App" style={{ margin: 0, padding: 0 }}>
      <Header restaurant={restaurant} />
      <Hero restaurant={restaurant} />
      <MenuSection restaurant={restaurant} />
      <Footer restaurant={restaurant} />
    </div>
  )
}
